import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';
import { Star } from '../packages/Stars/Star';
import { UIHeading3 } from '@cian/ui-kit';
import { formatRate } from '../../utils/getResponseTimeText';

export type TSize = 'S' | 'M';

export interface IOneStarRateProps {
  uniqueKey: string;
  reviewsRate: number;
  size?: TSize;
}

export const OneStarRate: React.FC<React.PropsWithChildren<IOneStarRateProps>> = props => {
  const { uniqueKey, reviewsRate, size = 'M' } = props;

  return (
    <div className={styles['wrap']}>
      <div className={cn(styles['star'], styles[`star-size_${size.toLocaleLowerCase()}`])}>
        <Star gradientId={uniqueKey} value={5} />
      </div>
      <UIHeading3>{formatRate(reviewsRate || 0)}</UIHeading3>
    </div>
  );
};

OneStarRate.displayName = 'OneStarRate';
